import React, { useEffect, useState } from "react";
import axios from "axios";
import {
  Box,
  Typography,
  Paper,
  Tabs,
  Tab,
  Alert,
  List,
  ListItem,
  ListItemText,
  Button,
} from "@mui/material";
import { useParams, useNavigate } from "react-router-dom";
import API_BASE_URL from "../../utils/api";
import Leaderboard from "../../components/Leaderboard/Leaderboard";

const authHeaders = () => ({
  Authorization: `Bearer ${localStorage.getItem("token")}`,
});

const TranscribeathonEventPage = () => {
  const { eventId } = useParams();
  const navigate = useNavigate();

  const [tab, setTab] = useState(0);
  const [event, setEvent] = useState(null);
  const [participants, setParticipants] = useState([]);
  const [error, setError] = useState("");

  const fetchEvent = async () => {
    try {
      const res = await axios.get(
        `${API_BASE_URL}/transcribeathon/public/events/${eventId}`
      );
      setEvent(res.data);
    } catch (err) {
      setError(err.response?.data?.error || "Failed to fetch event");
    }
  };

  const fetchParticipants = async () => {
    try {
      const res = await axios.get(
        `${API_BASE_URL}/transcribeathon/public/events/${eventId}/participants`
      );
      setParticipants(res.data);
    } catch (err) {
      setError(err.response?.data?.error || "Failed to fetch participants");
    }
  };
  useEffect(() => {
    document.title = "Transcribe-athon event - MS Digital Hub";
  }, []);
  useEffect(() => {
    fetchEvent();
    fetchParticipants();
  }, [eventId]);

  return (
    <Box sx={{ p: 3 }}>
      <Box
        sx={{
          width: "auto",

          padding: "0px 20px",
          margin: "0px auto",
          padding: { xs: "20px", sm: "30px", md: "1px 80px" },
          border: "none",
          backgroundColor: "#ffffff",
          borderRadius: "8px",
        }}
      >
        {" "}
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            mb: 2,
            gap: 2,
            flexWrap: "wrap",
          }}
        >
          <Box>
            <Typography variant="h5">
              {event?.name || "Transcribe-athon Event"}
            </Typography>
            {event && (
              <Typography variant="body2" color="text.secondary">
                {new Date(event.startsAt).toLocaleString("en-US", {
                  timeZone: "America/Chicago",
                })}{" "}
                —{" "}
                {new Date(event.endsAt).toLocaleString("en-US", {
                  timeZone: "America/Chicago",
                })}
              </Typography>
            )}
          </Box>

          <Button variant="outlined" onClick={() => navigate("/transcription")}>
            Back to Transcription
          </Button>
        </Box>
        {error && (
          <Alert severity="error" sx={{ mb: 2 }}>
            {error}
          </Alert>
        )}
        <Tabs
          value={tab}
          onChange={(_, newValue) => setTab(newValue)}
          sx={{ mb: 3 }}
        >
          <Tab label="Participants" />
          <Tab label="Leaderboard" />
        </Tabs>
        {tab === 0 && (
          <Box>
            <Typography variant="h6" sx={{ mb: 2 }}>
              Participants
            </Typography>

            {participants.length === 0 ? (
              <Typography color="text.secondary">
                No participants added yet.
              </Typography>
            ) : (
              <List>
                {participants.map((participant) => {
                  const fullName =
                    participant?.userId?.name ||
                    participant.displayNameSnapshot ||
                    "Participant";

                  const firstName = fullName.split(" ")[0];

                  return (
                    <ListItem key={participant._id} divider>
                      <ListItemText
                        primary={firstName}
                        secondary={participant?.userId?.email || ""}
                      />
                    </ListItem>
                  );
                })}
              </List>
            )}
          </Box>
        )}
        {tab === 1 && (
          <Box>
            <Leaderboard eventId={eventId} />
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default TranscribeathonEventPage;
